import styled from "styled-components";
import PropTypes from "prop-types";
import { device } from "../device";

const margin = ({ margin = "0 0 32px" }) => margin;

const H2 = styled.h2`
    margin: ${margin};

    font-size: 32px;
    font-weight: 500;
    line-height: 1.2;

    @media ${device.lg} {
        font-size: 48px;
    }
`;

H2.propTypes = {
    margin: PropTypes.string
};

export default H2